/** Service worker registration + offline queue UX */
import { toast } from "sonner";

export function registerSW() {
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production" && !window.location.hostname.endsWith(".emergentagent.com")) {
    // Still register in preview for testing PWA
  }
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js")
      .then(() => {})
      .catch(() => {});
  });

  navigator.serviceWorker.addEventListener?.("message", (e) => {
    if (e.data?.type === "queue-flushed" && e.data.count > 0) {
      toast.success(`${e.data.count} feuille(s) de match synchronisée(s).`);
    }
  });

  window.addEventListener("online", () => {
    toast.success("Connexion rétablie. Synchronisation en cours…");
    navigator.serviceWorker.ready.then((reg) => {
      reg.active?.postMessage({ type: "flush-queue" });
    });
  });

  window.addEventListener("offline", () => {
    toast.warning("Mode hors-ligne — la saisie des stats sera synchronisée automatiquement.");
  });
}
